import actionComposer from 'utilities/actionComposer';
import { queryContentStackByType } from 'utilities/contentStack';

export const GET_USER_PROMO_STACK = actionComposer('GET_USER_PROMO_STACK');
export const getUserPromoStack = () => ({
  type: GET_USER_PROMO_STACK.type,
  payload: queryContentStackByType('user_promo')
});
